import React, { useEffect, useState } from 'react';
import {
  List, ListSubheader, ListItemButton, ListItemIcon, ListItemText, Collapse
} from '@mui/material';

import { useNavigate, Link, useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Avatar,
  Chip,
  Card,
  TextField,
  Pagination,
  CardContent,
  MenuItem
} from '@mui/material';
import { FaCalendarAlt, FaPrint } from 'react-icons/fa';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import AppBarComponent from '../../../component/appbar';
import { GetAllBookings, getBookingByDate, getCountTicketByDate, searchBookings } from '../../../service/booking_service';
import { FiAlertCircle, FiDownload } from "react-icons/fi";
import '../../../style/style.css';
import { getTimeSlotsActive, GetDownloadExcelBookingByDate, getTimeSlotSpecialDay, getBookingByDateTime } from '../../../service/utinity_service';
import BoatScheduleTimeline from '../Boatmanagmet/test/test';
import { TimeSlotsMock } from '../../../utility/timeslots';
import './style.css';
import { MdPreview } from "react-icons/md";
import { MdTitle, MdPeople, MdChair, MdAttachMoney } from 'react-icons/md';
import { FaPlus } from "react-icons/fa";

const ITEMS_PER_PAGE = 10;
const Dashboard_View = () => {
  // const timeSlots = TimeSlots
  const [timeSlots, setTimeSlots] = useState(TimeSlotsMock)


  const navigate = useNavigate();
  const token = Cookies.get('token')
  const [selectedDate, setSelectedDate] = useState(dayjs());;
  const [TicketData, setTicketData] = useState(timeSlots);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [bookings, setBookings] = useState([]);
  const [page, setPage] = useState(1);
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const [dataFetched, setDataFetched] = useState(true)
  const [maxPeople, setMaxPeople] = useState(0);
  const [countBookings, setCountBookings] = useState(0);
  const [timeSelect, setTimeSelect] = useState([])
  const dataFrom = {
    booking_id: '',
    first_name: '',
    last_name: '',
    status: '',
    boat: '',
    time: '',
  }

  const [datafrom, setDataFrom] = useState(dataFrom)

  const [cardData, setCardData] = useState([
    { title: "ข้อมูลในตาราง", content: '', icon: MdTitle, isAble: true },
    { title: 'จำนวนผู้ใช้บริการวันนี้', content: '30 คน', icon: MdPeople, isAble: true },
    { title: 'มีที่นั่งเรือว่างสำหรับวันนี้อีก', content: '15 ที่นั่ง', icon: MdChair, isAble: true },
    { title: 'รายได้วันนี้', content: '43,200.00 บาท', icon: MdAttachMoney, isAble: true },
  ])


  useEffect(() => {

    if (!token) {
      navigate('/login');
      return;
    }

    if (dataFetched) {
      handleGetBookingByToday()
      const date = new Date()
      const formattedDate = formatDate(date);
      handleGetCountTicketByDate(formattedDate)
    }
    //handleGetTimeSlot()
    handleGetTimeSlot()
    setTotalCount(0)
    setDataFetched(false)
  }, [selectedDate]);

  const displayedBookings = Array.isArray(bookings) ? bookings.slice(startIndex, endIndex) : [];
  const totalPages = Math.ceil(bookings.length / ITEMS_PER_PAGE);

  const handleDateChange = (newDate) => {
    if (newDate !== selectedDate) {
      setSelectedDate(newDate);
      const formattedDate = formatDate(newDate);
      handleGetCountTicketByDate(formattedDate);
      handleGetBookingByDate(formattedDate);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDataFrom(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleGetTimeSlot = async () => {
    try {
      const res = await getTimeSlotsActive();
      setTimeSelect(res);
    } catch (e) {
      console.error('Error getting time slots:', e);
    }
  }

  const handleGetExcelBookingByDate = async () => {
    try {
      const res = await GetDownloadExcelBookingByDate(formatDate(selectedDate), token);
    } catch (e) {
      console.error('Error downloading Excel file:', e);
    }
  }

  const formatDate = (date) => {
    const jsDate = new Date(date.$d || date); // ตรวจสอบว่ามีคุณสมบัติ $d หรือไม่ และสร้างวัตถุ Date
    const day = String(jsDate.getDate()).padStart(2, '0');
    const month = String(jsDate.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มที่ 0
    const year = jsDate.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleGetAllBooking = async () => {
    try {
      const res = await GetAllBookings(token);
      if (Array.isArray(res)) {
        setBookings(res); // Only set bookings if it's a valid array
        //console.log("result: ", res);
        // console.log("Get Booking : ", bookings);
        let totalPrice = 0;
        res.forEach((item) => { 
          if(item.status !== "ยกเลิก" && item.status !== "ชำระเงินไม่สำเร็จ"){
            totalPrice += item.total_price;
          }   // Accumulate total price
        });
        setTotalPrice(totalPrice);
        const tempCardata = cardData
        tempCardata[0].content = 'ข้อมูลการจองทั้งหมด'
        tempCardata[1].isAble = false
        tempCardata[2].isAble = false
        tempCardata[3].isAble = false
        setCardData(tempCardata)
        setCountBookings(res.length)
        setSelectedDate(dayjs())
        setPage(1)
      } else {
        console.error('Invalid data structure for bookings:', res);
      }
    } catch (e) {
      console.log('Error fetching bookings:', e);
    }
  };

  const handleGetBookingByDate = async (formattedDate) => {
    try {
      const response = await getBookingByDate(formattedDate, token);
      if (Array.isArray(response)) {
        setBookings(response);
        setCountBookings(response.length);
      } else {
        console.error('Invalid response data for bookings:', response.data);
      }
    } catch (e) {
      console.log('Error fetching bookings by date:', e);
    }
  };

  const handleGetBookingByToday = async () => {
    try {
      const response = await getBookingByDate(formatDate(new Date()), token);
      // console.log("getBookingByDate",response);
      if (Array.isArray(response)) {
        setBookings(response);
        setCountBookings(response.length);
        const tempCardData = cardData
        tempCardData[0].content = `ข้อมูลการจองวันนี้ ${formatDate(new Date())}`
        tempCardData[1].isAble = true
        tempCardData[2].isAble = true
        tempCardData[3].isAble = true
        setCardData(tempCardData)
        let totalPrice = 0;
        response.forEach((item) => {   
          if(item.status !== "ยกเลิก" && item.status !== "ชำระเงินไม่สำเร็จ"){
            item.total_price = parseFloat(item.total_price.toFixed(2));    // Accumulate total count of tickets
            totalPrice += item.total_price;
          }   // Accumulate total price
        });
        setTotalPrice(totalPrice);
        setSelectedDate(dayjs())
        setPage(1)
      } else {
        console.error('Invalid response data for bookings:', response.data);
      }
    } catch (e) {
      console.error('Error fetching bookings by date:', e);
    }
  };

  const handleGetBookingByDateTime = async (date, time) => {
    try {
      // console.log('handleGetBookingByDateTime', date);
      const res = await getBookingByDateTime(date, time, token);
      // console.log("result: ", res);
      setBookings(res);
    } catch (error) {
      setBookings([])
    }
  }

  const handleGetCountTicketByDate = async (newDate) => {
    try {
      const res = await getCountTicketByDate(newDate, token);
      // console.log("Count getCountTicketByDate :", res);
      //console.log("Time slots:", timeSlots);
      setCountBookings(res.length);

      let resTimeslot = await getTimeSlotSpecialDay(newDate);
      // console.log("Count getTimeSlotSpecialDay:", resTimeslot);

      if (resTimeslot.length <= 0) {
        resTimeslot = await getTimeSlotsActive();
        // console.log("Time slots:", resTimeslot);
      }

      let totalCount = 0;
      let totalPrice = 0;
      let maxPeople = 0;

      res.forEach((item) => {
          totalCount += item.total_people;         // Accumulate total count of tickets
          totalPrice += item.total_price;
          // console.log("statust",item)   // Accumulate total price
      });

      resTimeslot.forEach((slot) => {
        // Accumulate total people for each time slot
        maxPeople += slot.total_people; // Accumulate
      })

      const updatedTimeSlots = resTimeslot.map((slot) => {
        // Improved matching logic
        const matchingData = res.find((item) => {
          const [slotStart] = slot.time.split(' - ');
          const [itemStart] = item.time.split(' - ');
          return slotStart === itemStart;
        }) || {
          total_adults: 0,
          total_children: 0,
          total_people: 0,
          total: slot.total_people,
        };

        // console.log(`Matching for ${slot.time}:`, matchingData);

        return {
          ...slot,
          total_adults: matchingData.total_adults,
          total_children: matchingData.total_children,
          total_people: matchingData.total_people,
          total: slot.total_people,
        };
      });

      // console.log("Updated Time Slots:", updatedTimeSlots);
      // console.log("totalCount", totalCount);
      // console.log("totalPrice", totalPrice);

      setTicketData(updatedTimeSlots);
      setTotalCount(totalCount);
      setTotalPrice(totalPrice);

      setMaxPeople(maxPeople);

      setCardData([
        { title: "ข้อมูลในตาราง", content: `ข้อมูลการจองวันที่ ${newDate}`, icon: MdTitle, isAble: true },
        { title: 'จำนวนผู้ใช้บริการวันนี้', content: `${totalCount} คน`, icon: MdPeople, isAble: true },
        { title: 'มีที่นั่งเรือว่างสำหรับวันนี้', content: `${maxPeople - totalCount} ที่นั่ง`, icon: MdChair, isAble: true },
        { title: 'รายได้วันนี้', content: `${totalPrice} บาท`, icon: MdAttachMoney, isAble: true },
      ])
      setPage(1)
    } catch (error) {
      console.error("Error fetching ticket count:", error);
      // Add user-friendly error handling here
    }
  };

  const handleSearchTicket = async (e) => {
    try {
      // console.log("Search ticket", datafrom);
      const res = await searchBookings(datafrom, token)
      setBookings(res)
    } catch (error) {
      console.error("Error fetching ticket count:", error);
    }
  }

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'เสร็จสิ้น':
        return { color: 'success', backgroundColor: '#e6f4ea', textColor: '#34a853' };
      case 'รอชำระเงิน':
        return { color: 'warning', backgroundColor: '#fff8e1', textColor: '#ffa000' };
      case 'ยกเลิก':
        return { color: 'error', backgroundColor: '#fde7e7', textColor: '#d32f2f' };
      case 'รอให้บริการ':
        return { color: 'info', backgroundColor: '#e3f2fd', textColor: '#1976d2' };
      case 'ชำระเงินไม่สำเร็จ':
        return { color: 'warning', backgroundColor: '#ede7f6', textColor: '#673ab7' };
      default:
        return { color: 'default', backgroundColor: '#f5f5f5', textColor: '#9e9e9e' };
    }
  };

  return (
    <Box sx={{ backgroundColor: '#EEF2F6' }}>
      <Box>
        <AppBarComponent />

        <Box sx={{ p: 3 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
            <Paper elevation={3} sx={{ p: 1, mb: 3, margin: '20px' }}>
              <Grid container alignItems="center" justifyContent="space-between" spacing={0} sx={{ border: '0px solid #f00' }}>
                <Grid item xs={12} sm={4} sx={{ border: '0px solid #0f0', padding: '10px' }}>
                  <Box display="flex" justifyContent={'space-between'} alignItems="center" mb={1}>
                    <Box display="flex" justifyContent={'space-between'} alignItems="center">
                      <FaCalendarAlt style={{ marginRight: '8px' }} />
                      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>ระบุวันที่ต้องการดูข้อมูล</Typography>
                    </Box>
                    {/* <Box>
                      <Chip label="รายการจองวันนี้" variant="outlined" sx={{ marginRight: '5px' }} onClick={handleGetBookingByToday} />
                      <Chip label="รายการจองทั้งหมด" variant="outlined" sx={{ marginRight: '5px' }} onClick={handleGetAllBooking} />
                    </Box> */}
                  </Box>

                  <Box display="flex" justifyContent={'space-between'} alignItems="center" mb={1} sx={{ width: '100%', border: '0px solid #f00' }}>
                    <DatePicker
                      value={selectedDate}
                      onChange={handleDateChange}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                      format="DD MMMM YYYY"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: '16px',
                          textAlign: 'left',
                          padding: '5px',
                          width: '100%',
                          position: 'relative'
                        }
                      }}
                    />
                    <Box>
                      <Chip label="รายการจองวันนี้" variant="outlined" sx={{ marginRight: '5px' }} onClick={handleGetBookingByToday} />
                      <Chip label="รายการจองทั้งหมด" variant="outlined" sx={{ marginRight: '5px' }} onClick={handleGetAllBooking} />
                    </Box>
                  </Box>

                </Grid>
                <Grid item xs={12} sm={3} textAlign="center">
                  <Card className='bgSummaryBox'>
                    <Typography variant="body1">จำนวน  Booking</Typography>
                    <Typography variant="h5">{countBookings}</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={3} textAlign="center">
                  <Card className='bgSummaryBox'>
                    <Typography variant="body1">รายได้</Typography>
                    <Typography variant="h5">
                      {typeof totalPrice === 'number'
                        ? `${new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(totalPrice)}`
                        : 'N/A'}                        บาท</Typography>
                    <Typography variant="body2">(รายการจองทั้งหมด {countBookings} รายการ)</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={2} sx={{ border: '0px solid #f00', padding: '0px 10px' }}>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FiDownload size={24} />}
                    fullWidth
                    sx={{
                      // backgroundColor: 'color="primary"',
                      margin: '10px',
                      height: '40px',
                      fontSize: '14px',
                      color: 'white',

                    }}
                    onClick={() => handleGetExcelBookingByDate()}
                  >
                    Download
                  </Button> */}
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FaPlus fontSize={24} />}
                    fullWidth
                    sx={{
                      // backgroundColor: 'color="primary"',
                      margin: '10px',
                      height: '40px',
                      fontSize: '14px',
                      color: 'white',

                    }}
                    onClick={(e) => navigate('/thewonderblueadmin_booking/create')}
                  >
                    เพิ่มรายการจอง
                  </Button>

                </Grid>
              </Grid>
            </Paper>
          </LocalizationProvider>
          {/* <Card sx={{ margin: 1 }}>
            <BoatScheduleTimeline></BoatScheduleTimeline>
          </Card> */}
          <Box sx={{ margin: '20px' }}>
            <Grid container spacing={3} sx={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={4} sx={{ paddingTop: '0px', marginTop: '0px', border: '0px solid #f00' }}>
                {/* <Typography variant="h6" gutterBottom>รอบเดินเรือ</Typography> */}
                {TicketData.length > 0 && (
                  <Paper elevation={3} sx={{ p: 2 }}>
                    <List
                      sx={{ width: '100%', bgcolor: 'background.paper', overflow: 'scroll', overflowX: 'hidden', height: '1040px' }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                      subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                          <Typography variant="h6" gutterBottom>รอบเดินเรือ {formatDate(selectedDate)}</Typography>
                        </ListSubheader>
                      }
                    >
                      {TicketData.map((slot, index) => (

                        <ListItemButton key={index} sx={{ borderBottom: '1px solid #efefef' }} onClick={(e) => handleGetBookingByDateTime(formatDate(selectedDate), slot.time)}>
                          <Avatar sx={{ mr: 2 }}>
                            {index + 1}
                          </Avatar>
                          <ListItemText
                            primaryTypographyProps={{ sx: { fontWeight: 'bold', color: 'primary.main', fontSize: '20px' } }}
                            primary={`${slot.time}`}
                            secondary={`ว่างอีก ${slot.total - (slot.total_adults + slot.total_children)} ที่นั่ง`}

                          />

                          <Typography variant="body2" align="right">
                            {/* <Chip label={`จำนวนผู้โดยสาร ${slot.total_adults+slot.total_children} คน`} variant="outlined" /> */}
                            <div> จำนวนผู้โดยสาร {slot.total_people} / {slot.total} คน</div>
                            <div><small> (ผู้ใหญ่ {slot.total_adults} , เด็ก {slot.total_children})</small></div>
                          </Typography>

                        </ListItemButton>

                        // <Card key={index} mb={2} sx={{ padding: 4, margin: 2 }} >
                        //   <Typography variant="body2" sx={{ fontSize: '24px' }}>รอบ : {slot.time}</Typography>
                        //   <LinearProgress
                        //     variant="determinate"
                        //     value={(slot.total_people / slot.total) * 100}
                        //     sx={{ height: 10, borderRadius: 5 }}
                        //   />
                        //   <Box display="flex" flexDirection="row" justifyContent="space-between">
                        //     <Typography variant="body2" align="left">
                        //       ผู้ใหญ่ {slot.total_adults} คน , เด็ก {slot.total_children}
                        //     </Typography>
                        //     <Typography variant="body2" align="right">
                        //       {slot.total_people}/{slot.total}
                        //     </Typography>
                        //   </Box>
                        // </Card>

                      ))}
                    </List>
                  </Paper>
                )}
              </Grid>
              {true ? (
                <Grid item xs={12} md={8}>
                  {/* <Typography variant="h5" gutterBottom color={'black'} fontWeight={'bold'}>
                    {title}
                  </Typography> */}
                  <Grid container spacing={2}>
                    {cardData.map((card, index) => (
                      <Grid item xs={6} sm={3} key={index}>
                        {card.isAble && (
                          <Card variant="outlined" sx={{ minWidth: 200, height: '100%' }}>
                            <CardContent>
                              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                <card.icon size={24} style={{ marginRight: '8px' }} />
                                <Typography variant="h6" component="div">
                                  {card.title}
                                </Typography>
                              </div>
                              <Typography variant="body2" color="text.secondary">
                                {card.content}
                              </Typography>
                            </CardContent>
                          </Card>
                        )}
                      </Grid>
                    ))}
                  </Grid>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
                    <Card sx={{ padding: 3, marginTop: 3, marginBottom: 3 }}>
                      <Typography variant="h6" gutterBottom>
                        ค้นหารายการจอง
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Ticket No.</Typography>
                          <TextField
                            name="booking_id"
                            label="Ticket No."
                            value={datafrom.booking_id}

                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Frist Name</Typography>
                          <TextField
                            name="first_name"
                            label="First Name"
                            value={datafrom.first_name}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Last Name</Typography>
                          <TextField
                            name="last_name"
                            label="Last Name"
                            value={datafrom.last_name}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            fullWidth
                          />
                        </Grid>
                        {/* <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Date</Typography>
                          <DatePicker
                            value={selectedDateFrom}
                            onChange={handleDateChangeFrom}
                            renderInput={(params) => <TextField
                              {...params}
                              // value={boatFrom.engine}
                              // onChange={handleBoatFromChange}
                              InputLabelProps={{ shrink: true }}
                              size="small"
                            />}
                            format="DD MMMM YYYY"
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: '15px',
                                textAlign: 'left',
                                padding: '10px',
                                width: '100%',
                                position: 'relative'
                              }
                            }}
                          />

                        </Grid> */}
                        {/* <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Time</Typography>
                          <TextField
                            select
                            name="time"
                            label="เวลา"
                            value={datafrom.time}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            fullWidth
                            SelectProps={{
                              MenuProps: {
                                PaperProps: {
                                  style: {
                                    maxHeight: 200, // กำหนดความสูงสูงสุดของเมนู (เช่น 200px)
                                  },
                                },
                              },
                            }}
                          >
                            {timeSelect.length > 0 &&
                              timeSelect.map((status) => (
                                <MenuItem key={status.time} value={status.time}>
                                  {status.time}
                                </MenuItem>
                              ))
                            }
                          </TextField>
                        </Grid> */}
                        {/* <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Boat</Typography>
                          <TextField
                            name="boat"
                            label="Boat"
                            value={datafrom.boat}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            fullWidth
                          />
                        </Grid> */}
                        <Grid item xs={12} sm={3}>
                          <Typography sx={{ marginBottom: 1, fontSize: '18px' }}>Status</Typography>
                          <TextField
                            select
                            name="status"
                            label="Status"
                            // value={boatFrom.status}
                            // onChange={handleBoatFromChange}
                            value={datafrom.status}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            fullWidth
                          >
                            <MenuItem value="เสร็จสิ้น">เสร็จสิ้น</MenuItem>
                            <MenuItem value="รอให้บริการ">รอให้บริการ</MenuItem>
                            <MenuItem value="รอชำระเงิน">รอชำระเงิน</MenuItem>
                            <MenuItem value="รอการตัดสินใจ">รอการตัดสินใจ</MenuItem>
                            <MenuItem value="ชำระเงินไม่สำเร็จ">ชำระเงินไม่สำเร็จ</MenuItem>
                            <MenuItem value="เลื่อน">เลื่อน</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button variant="outlined" color="primary" sx={{ marginRight: 2, width: '200px' }}
                          onClick={(e) => setDataFrom(dataFrom)}
                        >
                          ล้างค่า
                        </Button>
                        <Button variant="contained" color="primary" sx={{ width: '200px' }}
                          onClick={handleSearchTicket}
                        >
                          ค้นหา
                        </Button>
                      </Box>
                    </Card>
                  </LocalizationProvider>
                  {displayedBookings && displayedBookings.length > 0 ? (
                    <Box>
                      <TableContainer component={Paper} boxShadow={4} style={{ height: '1000px', overflow: 'scroll', overflowX: 'hidden', marginTop: '20px', overflowX: 'auto' }}>
                        <Table boxShadow={4}>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ minWidth: '100px' }}>Ticket No.</TableCell>
                              {/* <TableCell>วันที่ใช้บริการ</TableCell> */}
                              <TableCell sx={{ minWidth: '180px' }}>Customer</TableCell>
                              <TableCell sx={{ minWidth: '120px' }}>Passenger</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell sx={{ minWidth: '80px' }}>Boat</TableCell>
                              <TableCell>Status</TableCell>
                              <TableCell sx={{ width: '50px' }}>Details</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {displayedBookings.map((booking) => (
                              <TableRow key={booking.id} sx={{ verticalAlign: 'top' }}>
                                <TableCell>
                                  <Typography sx={{ fontSize: '14px' }}>{booking.booking_id || 'N/A'}</Typography>
                                  <Typography variant="body2" sx={{ fontSize: '12px' }}>📆 {booking.date || 'N/A'}</Typography>
                                  <Typography variant="body2" sx={{ fontSize: '12px' }}>⏱ {booking.time || 'N/A'}</Typography>
                                  {/* <Typography><small>⚓️{booking.ticketboat_name || '(ยังไม่เลือกเรือ)'}</small></Typography> */}
                                </TableCell>
                                {/* <TableCell>
                              <Typography variant="body2">📆{booking.date || 'N/A'}</Typography>
                              <Typography variant="body2">⏱{booking.time || 'N/A'}</Typography>
                            </TableCell> */}
                                <TableCell>
                                  <Box display="flex" alignItems="center">
                                    {/* <Avatar sx={{ mr: 2 }}>
                                  {booking.name && booking.name.length >= 2
                                    ? `${booking.first_name[0]}${booking.first_name[1]}`
                                    : ''}
                                </Avatar> */}
                                    <Box>
                                      <Typography>คุณ {booking.first_name || 'N/A'} {booking.last_name || 'N/A'}</Typography>
                                      <Typography sx={{ fontSize: '12px' }}>📞 {booking.tel || 'N/A'}</Typography>
                                      <Typography sx={{ fontSize: '12px' }}>✉️ {booking.email || 'N/A'}</Typography>
                                    </Box>
                                  </Box>
                                </TableCell>

                                <TableCell>
                                  <Typography variant="body2" sx={{ fontSize: '16px' }}>จำนวน {booking.total_people || 'N/A'} คน</Typography>
                                  <Box>
                                    <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                      {booking.adults ? `ผู้ใหญ่ ${booking.adults} คน` : ``}{booking.children ? `, เด็ก ${booking.children} คน` : ``}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  {typeof booking.total_price === 'number'
                                    ? `${new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(booking.total_price)}`
                                    : 'N/A'}
                                </TableCell>
                                <TableCell>
                                  {/* <Typography>⚓️{booking.ticketboat_name || 'N/A'}</Typography> */}
                                  {booking.ticketboat_name ? `⚓️ ${booking.ticketboat_name}` : `❕ยังไม่เลือกเรือ`}
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={booking.status || 'N/A'}
                                    size="medium"
                                    sx={{
                                      width: '100%',
                                      backgroundColor: getStatusColor(booking.status).backgroundColor,
                                      borderColor: getStatusColor(booking.status).textColor,
                                      '& .MuiChip-label': {
                                        color: getStatusColor(booking.status).textColor,
                                      },
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Button

                                    size="medium"
                                    sx={{
                                      width: '90%',
                                      backgroundColor: '้gray',
                                      borderColor: 'white',
                                      '& .MuiChip-label': {
                                        color: 'white',
                                      },
                                    }}
                                    onClick={() => navigate('/thewonderblueadmin_edit/' + booking.booking_id)}
                                  >
                                    <MdPreview fontSize={'24px'} color='gray' />
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Box display="flex" justifyContent="center" mt={2}>
                        <Pagination
                          count={totalPages}
                          page={page}
                          onChange={handleChangePage}
                          color="primary"
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      marginTop={'8px'}
                      flexDirection="column" // จัดเรียงไอคอนและข้อความในแนวตั้ง
                    >
                      <FiAlertCircle style={{ fontSize: 50, color: "#1976d2" }} /> {/* ขนาดไอคอนและสี */}
                      <Typography>No bookings available</Typography> {/* ข้อความแจ้งเตือน */}
                    </Box>
                  )}

                </Grid>
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                  width={'60%'}
                  marginTop={20}
                  flexDirection="column" // จัดเรียงไอคอนและข้อความในแนวตั้ง
                >
                  <FiAlertCircle style={{ fontSize: 50, color: "#1976d2" }} /> {/* ขนาดไอคอนและสี */}
                  <Typography>No bookings available</Typography> {/* ข้อความแจ้งเตือน */}
                </Box>
              )}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box >
  );
};

export default Dashboard_View;